import { useEffect } from "react";
import NuVidioWidget from "nuvidio-widget-js";
import { envs } from "../../config";

const useNuvidio = () => {
  useEffect(() => {
    NuVidioWidget.importScripts();
    NuVidioWidget.setDepartment(envs.nuvidioId, {
      fabButton: false,
    });
    return () => {
      // É recomendado remover o widget caso ele não seja utilizado em outros componentes
      NuVidioWidget.removeWidget();
    };
  }, []);
};

export default useNuvidio;
